import { ContentfulTemplatePodcast } from 'graphqlTypes';
import { FC } from 'react';

import musicImg from 'assets/images/podcast/music.svg';
import spotifyImg from 'assets/images/podcast/spotify.svg';
import xmlidImg from 'assets/images/podcast/xmlid.svg';
import youtubeImg from 'assets/images/podcast/youtube.svg';

import Flex from 'quarks/Flex';
import Image, { ImageData } from 'quarks/Image';
import Link from 'quarks/Link';
import Text from 'quarks/Text';

const textWrapCSS = `
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const podcastData = [
  {
    id: 1,
    href: 'https://open.spotify.com/show/0xgfGTzqcCflFqwa3e1F0T?si=kCPr_swlScC6k7M1QDE79Q&nd=1',
    image: spotifyImg,
  },
  { id: 2, href: 'https://www.youtube.com/playlist?list=PL06vzBGwqWSSF0_gqLftW7CupalC8WAFS', image: youtubeImg },
  { id: 3, href: 'https://podcasts.apple.com/us/podcast/field-famous/id1672665453', image: xmlidImg },
  {
    id: 4,
    href: 'https://music.amazon.com/podcasts/8349710b-8b85-478e-a32d-f00df75d068e/field-famous',
    image: musicImg,
  },
];

export type NextPodcastProps = {
  relatedPost?: ContentfulTemplatePodcast;
};

const convertDuration = (secs: number) => {
  const hours = Math.floor(secs / 3600);
  const minutes = Math.floor((secs - hours * 3600) / 60);
  const seconds = (secs - hours * 3600 - minutes * 60).toString().padStart(2, '0');

  return `${hours || ''}${hours ? ':' : ''}${minutes.toString().padStart(2, '0')}:${seconds}`;
};

const NextPodcast: FC<NextPodcastProps> = ({ relatedPost }) =>
  relatedPost ? (
    <Flex
      flexDirection="column"
      width="100%"
      borderRadius="12px"
      backgroundColor="common-white"
      lg={{ paddingAll: 24, border: '1px solid', borderColor: 'gray-200' }}
    >
      <Flex
        flexDirection="column"
        width="100%"
        gap="16px"
        paddingBottom={relatedPost ? 16 : 0}
        borderBottom={relatedPost ? '1px solid' : undefined}
        borderColor="gray-50"
        display="none"
        lg={{ display: 'flex' }}
      >
        {relatedPost && (
          <Text textColor="gray-900" fontWeight="semiBold">
            Listen Next
          </Text>
        )}
        {relatedPost && (
          <Link href={`/resources/podcast/${relatedPost?.slug}`} textDecoration="none">
            <Flex width="100%" flexDirection="column" justifyContent="space-between" gap="16px">
              <Image
                image={relatedPost?.featuredImage as ImageData}
                alt={relatedPost?.featuredImage?.title || 'Podcast Detail Image'}
                width="100%"
                height="125px"
                objectFit="cover"
                borderRadius="4.75px"
              />
              <Flex flexDirection="column" gap="4px">
                {relatedPost?.title && (
                  <Text textStyle="textSm" fontWeight="bold" textColor="gray-900" css={textWrapCSS}>
                    {relatedPost?.title}
                  </Text>
                )}
                <Text textStyle="textSm" textColor="gray-700">
                  {convertDuration(relatedPost?.duration)}
                </Text>
              </Flex>
            </Flex>
          </Link>
        )}
      </Flex>
      <Flex flexDirection="column" width="100%" gap="24px" paddingTop={16}>
        <Text textColor="gray-900" fontWeight="semiBold">
          Rate & Subscribe
        </Text>
        <Flex width="fit-content" alignItems="center" justifyContent="space-between" gap="16px" lg={{ width: '100%' }}>
          {podcastData.map(link => (
            <Link href={link.href} key={link.id}>
              <Image image={{ file: { url: link.image } }} alt="Podcast Music Icon" width="35px" height="35px" />
            </Link>
          ))}
        </Flex>
      </Flex>
    </Flex>
  ) : null;

export default NextPodcast;
